module.exports = __webpack_public_path__ + "static/media/performance-sad-face.4b13d4e9.svg";